import "./Tienda.css";

import vipImg from "../assets/tienda/vip.jpg";
import vipPlusImg from "../assets/tienda/vipplus.jpg";
import eliteImg from "../assets/tienda/elite.jpg";

const rangos = [
  {
    nombre: "VIP",
    precio: "$ 10.00",
    duracion: "30 DÍAS",
    destacado: "MÁS POPULAR",
    clase: "vip",
    imagen: vipImg,
    beneficios: [
      "Pago de 30000$ ",
      "Acceso a Kit VIP",
      "Acceso a la Camiseta del Club Oficial (Exclusiva)",
      "Acceso a roles exclusivos",
      "Acceso a comando especial Heal (Cada 24h)",
      "Rango en el servidor de Discord (Permanente)",
      "Acceso a canales de voz VIP (Permanente)",
      "Rango en el servidor de Roleplay",
      "Puede tener 2 trabajos a la vez",
      "Puedes tener 2 viviendas como máximo",
      "1 Vehiculo gratis a tu elección",
      "Chat Custom en el servidor de Roleplay",
    ],
  },
  {
    nombre: "VIP+",
    precio: "$ 20.00",
    duracion: "30 DÍAS",
    clase: "vipplus",
    imagen: vipPlusImg,
    beneficios: [
      "Pago de 70000$ ",
      "Acceso a Kit VIP",
      "Acceso a Kit VIP Plus",
      "Acceso a la Camiseta del Club Oficial (Exclusiva)",
      "Acceso a roles exclusivos",
      "Acceso a comando especial Heal (Cada 12h)",
      "Rango en el servidor de Discord (Permanente)",
      "Acceso a canales de voz VIP (Permanente)",
      "Rango en el servidor de Roleplay",
      "Puede tener 2 trabajos a la vez",
      "Puedes tener 3 viviendas como máximo",
      "2 Vehiculo gratis a tu elección",
      "Chat Custom en el servidor de Roleplay",
      ],
  },
  {
    
    nombre: "VIP ELITE",
    precio: "$ ???",
    duracion: "30 DÍAS",
    clase: "elite",
    imagen: eliteImg,
    beneficios: [      
      "???",
      "???",  
      "???",
      "???",
      "???",
      "???",
      "???",
      "???",
       "???",
      "???",
      "???",
       "???",
      "???",
      "???",
      "???",
      "???",
      ],
  },
];


const Tienda = () => {
  return (
    <main className="tienda-page">
      <section className="tienda-header">
        <span>🛒 TIENDA OFICIAL</span>
        <h1>
          Rangos <strong>VIP</strong>
        </h1>
        <p>Apoya al servidor y obtén beneficios exclusivos dentro del juego.</p>
        <p>Recuerda enviar la constancia de pago al Discord Oficial del servidor y contactarte con el Dueño.</p>
      </section>

      <section className="rangos-section">
        <div className="rangos-grid">
          {rangos.map((rango) => (
            <article className={`rango-card ${rango.clase}`} key={rango.nombre}>
              {rango.destacado && (
                <span className="rango-destacado">⭐ {rango.destacado}</span>
              )}

              <div className="rango-imagen">
                <img src={rango.imagen} alt={rango.nombre} />
              </div>

              <div className="rango-body">
                <h2>{rango.nombre}</h2>
                <p className="rango-precio">{rango.precio}</p>
                <span className="rango-duracion">{rango.duracion}</span>

                <ul>
                  {rango.beneficios.map((beneficio, index) => (
                    <li key={index}>✔ {beneficio}</li>
                  ))}
                </ul>

                <a
                  href="https://paypal.me/augustofc"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="comprar-btn"
                >
                  🛒 COMPRAR AHORA
                </a>
              </div>
            </article>
          ))}
        </div>          
        
        <div className="tienda-info">
          <div>
            <strong>🛡 Pago 100% Seguro</strong>
            <p>Transacciones protegidas</p>
          </div>

          <div>
            <strong>⚡ Entrega Automática</strong>
            <p>Rango al instante</p>
          </div>

          <div>
            <strong>🎧 Soporte 24/7</strong>
            <p>Estamos para ayudarte</p>
          </div>

          <div>
            <strong>🎁 Beneficios Exclusivos</strong>
            <p>Mejora tu experiencia</p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Tienda;